import { createEvent, createStore, sample } from 'effector'

export type TPaidServiceFastFilter = {
  /** 1 — мои в работе, 2 — мои завершённые */
  myInWork?: number | null
  /** 1 — только непрочитанные */
  myInWorkUnread?: number | null
}

// Инициализация из query-параметров ссылки (?myInWork=1&myInWorkUnread=1),
// чтобы первый запрос списка/канбана сразу уходил с фильтром
const urlParams = new URLSearchParams(window.location.search)
const urlMyInWork = Number(urlParams.get('myInWork')) || null

export const $paidServiceFastFilter = createStore<TPaidServiceFastFilter>({
  myInWork: urlMyInWork,
  myInWorkUnread: urlMyInWork
    ? Number(urlParams.get('myInWorkUnread')) || null
    : null
})

export const addFieldToPaidServiceFastFilter =
  createEvent<TPaidServiceFastFilter>()
export const setPaidServiceFastFilter = createEvent<TPaidServiceFastFilter>()

sample({
  source: $paidServiceFastFilter,
  clock: addFieldToPaidServiceFastFilter,
  fn: (store, field) => ({ ...store, ...field }),
  target: $paidServiceFastFilter
})

$paidServiceFastFilter.on(
  setPaidServiceFastFilter,
  (_, filter) => filter
)
